import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setPaymentCollection = async (context) => {
  const body = {
    active: true,
  };
  const { data } = await api().post('inventory.get-payment_mode', body);
  const filteredData = data.filter((e) => e.name.toLowerCase() !== 'shipay');

  context.commit(types.SET_PAYMENT_COLLECTION, filteredData);
};
